import { loadModules } from 'esri-loader';

export const esriOptions = {
  url: 'https://js.arcgis.com/4.23/',
  css: 'https://js.arcgis.com/4.23/esri/themes/light/main.css'
};

export function loadMap(container: any, basemap: string) {
  return loadModules(
    ['esri/core/urlUtils', 'esri/layers/MapImageLayer', 'esri/Map', 'esri/views/MapView'],
    esriOptions
  ).then(([urlUtils, MapImageLayer, Map, MapView]) => {
    urlUtils.addProxyRule({
      urlPrefix: 'https://pttarcgisserver.pttplc.com/giscenter/rest/services',
      proxyUrl: `https://pttship-gis.pttplc.com/pttship-api/app/${btoa(
        'user=acc&system=map'
      )}/api/AppProxy`
    });
    const layer = new MapImageLayer({
      url: 'https://pttarcgisserver.pttplc.com/giscenter/rest/services/PTT_SHIP/PTT_SHIP_MAP/MapServer'
    });

    const map = new Map({ basemap });
    map.add(layer);
    const view = new MapView({
      container,
      map,
      center: [101.148569, 12.720385],
      zoom: 15,
      rotation: 60
    });
    return view;
  });
}
